import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import LoadingData from "../../Common/LoadingData";



const AllInstructors = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/users?role=Instructor`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setData(data.msg);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDelete = (id) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/user/${id}`, {
      method: "DELETE",
      credentials: "include",
    }).then(() => {
      console.log("article deleted successfully");
      setData(data.filter((item) => item._id !== id));
    });
  };

  // if (loading) {
  //   return <LoadingData />;
  // }

  return (
    loading ? <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
    <div className="lds-dual-ring"></div>
  </div> :
    <section>
      <div className="container">
        <div className="row">
          <div className="col-md-11 m-auto">
            <div className="add-page">
              <table>
                <caption>All Instructors</caption>
                <thead>
                  <tr>
                    <th>Instructor Name</th>
                    <th>Email</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>{`${item.first_name} ${item.last_name}`}</td>
                      <td>{item.email}</td>
                      <td>
                        <span onClick={() => handleDelete(item._id)}>
                          <AiFillDelete />
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllInstructors;
